import * as actions from "./actions";
import AsyncStorage from "@react-native-async-storage/async-storage";

import NetInfo from "utils/network/netinfo";

export const setConnectionFlag = actions.setConnectionFlag;

export const storeWiFiDetails = actions.storeWiFiDetails;

/**
 * WiFi ssid and bssid are available only after user has granted location
 * permission. Update WiFi details after permission has been granted.
 */
export const forceFetchWifiState = () => dispatch => {
  if (NetInfo) {
    return NetInfo.fetch("wifi").then(wifiState => {
      const wifiDetails = {
        wifi_name: wifiState.details.ssid,
        wifi_mac: wifiState.details.bssid,
        wifi_connected_at: new Date(),
      };
      dispatch(storeWiFiDetails(wifiDetails));
      AsyncStorage.setItem("network", JSON.stringify(wifiDetails));
    });
  }
};
